<template>
  <a-card
    class="best-case-card"
    :body-style="{ padding: 0 }"
  >
    <template #title>
      <div class="best-case-header">
        {{ $t('bestCase.title') }}
        <a-button
          type="text"
          @click="$emit('update:isVisible', false)"
        >
          <template #icon>
            <CloseOutlined />
          </template>
        </a-button>
      </div>
    </template>
    <a-tabs
      v-model:activeKey="activeKey"
      :animated="false"
    >
      <a-tab-pane
        v-for="(position, index) in $tm('bestCase.roles')"
        :key="index"
        :tab="position.name"
      >
        <a-space
          direction="vertical"
          class="space-flex"
        >
          <a-card
            v-for="(objective, objectiveIndex) in position.objectives"
            :key="objectiveIndex"
            :bordered="false"
            :body-style="{
              backgroundColor: '#fafafa',
              padding: '12px'
            }"
          >
            <div class="okr-item objective">
              O{{ objectiveIndex + 1 }}: {{ $rt(objective.content) }}
              <IconFont
                type="iconmubiao"
                class="icon-block okr-item__icon objective"
                :style="{ fontSize: '20px' }"
              />
            </div>
            <div
              v-for="(keyResult, keyResultIndex) in objective.keyResults"
              :key="keyResultIndex"
              class="okr-item"
            >
              {{ $rt(keyResult) }}
              <KeyResultIcon
                :index="keyResultIndex + 1"
                :size="18"
                class="okr-item__icon key-result"
              />
            </div>
          </a-card>
        </a-space>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>

<script>
import { ref } from 'vue'
import { CloseOutlined } from '@ant-design/icons-vue'

import KeyResultIcon from '@/components/KeyResultIcon'

export default {
  components: {
    CloseOutlined,
    KeyResultIcon
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true
    }
  },
  emits: [
    'update:isVisible'
  ],
  setup () {
    return {
      activeKey: ref(0)
    }
  }
}
</script>

<style lang="less" scoped>
:deep(.ant-tabs-tabpane) {
  height: calc(100vh - 88px);
  overflow-y: auto;
  padding: 16px;
}

:deep(.ant-tabs-bar) {
  margin: 0;
}

.best-case-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
}

.okr-list-card {
  background-color: #FAFAFA;
}

.okr-item {
  margin: 8px 0 4px 28px;
  position: relative;

  &__icon {
    position: absolute;
  }

  .objective {
    top: 1px;
    left: -28px;
  }

  .key-result {
    top: 2px;
    left: -27px;
  }
}
</style>

<style lang="less">
.best-case-card {
  position: fixed;
  right: 482px;
  top: 0;
  bottom: 0;
  z-index: 1001;
  box-sizing: border-box;
  width: 500px;
  height: 100vh;
}
</style>

<style lang="less" scoped>
:deep(.ant-card-head-title) {
  padding: 8px 0 !important;
}
</style>
